const ENV = "DEV";

const configs = {
  LOCAL: {
    apiBaseUrl: "http://localhost:3001/",
    apiBaseUrlpy: "https://api.boovinzxfs.me/"
  },
  DEV: {
    apiBaseUrl: "https://api.boovinzxfs.me/",
    apiBaseUrlpy: "https://api.boovinzxfs.me/"
  },
  PROD: {
    apiBaseUrl: "https://api.vaithiyarpoovafoundation.com/",
    apiBaseUrlpy: "https://py.vaithiyarpoovafoundation.com/"
  }
};

const config = () => configs[ENV];

const configModule = { config };

export default configModule;

